export class SmeltingProductQuality {
    constructor({
          id= null, 
          planCode= ``, 
          day= ``,
          locName= ``,          
          shift='',
          furnaceName= ``, 
          furnaceBatch= ``,
          productName= ``,
          in_Cr2O3= ``,
          in_MA= ``,
          in_Al2O3= ``,
          in_CrFe= ``,
          pro_FeCr= ``,
          pro_FeSi= ``,
          pro_FeC= ``,
          pro_FeS= ``,
          pro_FeP= ``,
          out_Cr2O3= ``,
          out_basicity_SiO2= ``,
          out_basicity_Al2O3= ``,
      } = {}) {
      this.id = id;
      this.planCode = planCode;
      this.day = day;
      this.locName = locName;     
      this.shift = shift;  
      this.furnaceName = furnaceName;
      this.furnaceBatch = furnaceBatch;
      this.productName = productName;
      this.in_Cr2O3 = in_Cr2O3;
      this.in_MA = in_MA;
      this.in_Al2O3 = in_Al2O3;
      this.in_CrFe = in_CrFe;
      this.pro_FeCr = pro_FeCr;
      this.pro_FeSi = pro_FeSi;
      this.pro_FeC = pro_FeC;
      this.pro_FeS = pro_FeS;
      this.pro_FeP = pro_FeP;
      this.out_Cr2O3 = out_Cr2O3;
      this.out_basicity_SiO2 = out_basicity_SiO2;
      this.out_basicity_Al2O3 = out_basicity_Al2O3;
    }
  }
  export function gridFields() {
    return Object.freeze([        
        {
          key: 'planCode',
          label: 'lbl.basic.planCode',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'locName',
          label: 'lbl.basic.locName',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'day',
          label: 'lbl.basic.day',
          sortable: true,
          form: {
            type: 'datepicker'
          }
        },    
        {
          key: 'shift',
          label: 'lbl.basic.shift',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        // {
        //   key: 'furnaceName',
        //   label: 'lbl.basic.furnaceName',
        //   sortable: true,
        //   form: {
        //     type: 'select',
        //     options: [
        //       {value:"default", text:"lbl.basic.select.one"},
        //       {value:"1", text:"opt.furnaceNumber1"},
        //       {value:"2", text:"opt.furnaceNumber2"},
        //       {value:"3", text:"opt.furnaceNumber3"},
        //       {value:"4", text:"opt.furnaceNumber4"},
        //       {value:"5", text:"opt.furnaceNumber5"},
        //       {value:"6", text:"opt.furnaceNumber6"},
        //     ]
        //   }
        // },
        // {
        //   key: 'furnaceBatch',
        //   label: 'lbl.basic.furnaceBatch',
        //   sortable: true,
        //   form: {
        //     type: 'input'
        //   }        
        // },                      
        {
          key: 'productName',
          label: 'lbl.prd.execution.productionName',
          sortable: false,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'in_Cr2O3',
          label: 'lbl.prd.execution.in_Cr2O3',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'in_MA',
          label: 'lbl.prd.execution.in_MA',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'in_Al2O3',
          label: 'lbl.prd.execution.in_Al2O3',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'in_CrFe',
          label: 'lbl.prd.execution.in_CrFe',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'pro_FeCr',
          label: 'lbl.prd.execution.pro_FeCr',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'pro_FeSi',
          label: 'lbl.prd.execution.pro_FeSi',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'pro_FeC',
          label: 'lbl.prd.execution.pro_FeC',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'pro_FeS',
          label: 'lbl.prd.execution.pro_FeS',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'pro_FeP',
          label: 'lbl.prd.execution.pro_FeP',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'out_Cr2O3',
          label: 'lbl.prd.execution.out_Cr2O3',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'out_basicity_SiO2',
          label: 'lbl.prd.execution.out_basicity_SiO2',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'out_basicity_Al2O3',
          label: 'lbl.prd.execution.out_basicity_Al2O3',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'operate',
          label: 'lbl.basic.update',
          form: {
              type: 'formatter'
          }
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new SmeltingProductQuality()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.planCodeFilter',
    'filter.plantFilter',
    'filter.shiftFilter',
    'filter.startDayFilter',
    'filter.endDayFilter', 
    'filter.furnaceName',    
  ];
  export const filter = {
    'planCodeFilter': "", 
    'plantFilter': "",
    'shiftFilter': "",
    'startDayFilter': "",
    'endDayFilter': "",
    'furnaceNameFilter': "",
  };